import React from "react";
import Header from "../general/Header";
import Aside from "../general/Aside";
import Footer from "../general/Footer";
import axios from '../../axios/axiosconf';
import { useEffect, useState } from "react";
import { useHistory } from "react-router";
import { Link } from "react-router-dom";
import Loading from "../general/Loading";
import { getPermisosPorCategoria } from "../../../resources/Helper";
import Unauthorized from "../general/Unauthorized";
import PermisosRolAcordeones, { PERMISOS_ROL_STYLES } from "./PermisosRolAcordeones";
import { aplicarPermisoAdministrarSuscripcion, buildPermisosRolSecciones, getAllPermissionIds } from "./permisosRolSecciones";

function NewRole() {

    const [loading, setLoading] = useState(false);
    const [loggedIn, setLoggedIn] = useState(false);
    const [hasPermission, setHasPermission] = useState(false);
    const [username, setUsername] = useState('');
    const [client, setClient] = useState([]);
    const [permissions, setPermissions] = useState([]);

    const [permisosPacientes, setPermisosPacientes] = useState([]);
    const [permisosFacturacion, setPermisosFacturacion] = useState([]);
    const [permisosContabilidad, setPermisosContabilidad] = useState([]);
    const [permisosGenerales, setPermisosGenerales] = useState([]);
    const [permisosAgenda, setPermisosAgenda] = useState([]);
    const [permisosAdministracion, setPermisosAdministracion] = useState([]);
    const [permisosPersonal, setPermisosPersonal] = useState([]);
    const [permisosReportes, setPermisosReportes] = useState([]);
    const [permisosIndicadores, setPermisosIndicadores] = useState([]);
    const [permisosConfiguracion, setPermisosConfiguracion] = useState([]);
    const [permisosLaboratorio, setPermisosLaboratorio] = useState([]);
    
    const [roleName, setRoleName] = useState('');
    const [roleDescription, setRoleDescription] = useState();
    const [rolePermissions, setRolePermissions] = useState([]);

    let history = useHistory();

    let userdata = [];
    let clientData = [];

    const addPermission = (permissionId) => {
        setRolePermissions(prevPermissions => {
            let newPermissions = [...prevPermissions];
            let permissionIndex = newPermissions.indexOf(permissionId);
            
            if (permissionIndex > -1) {
                newPermissions.splice(permissionIndex, 1);
            } else {
                newPermissions.push(permissionId);
            }

            console.log('Updated permissions:', newPermissions);
            return newPermissions;
        });
    }

    // 🔄 Función para marcar/desmarcar todos los permisos de una sección
    const toggleAllPermissions = (sectionPermissions, sectionName) => {
        const sectionIds = sectionPermissions.map(p => p.id);
        const allSelected = sectionIds.every(id => rolePermissions.includes(id));
        
        setRolePermissions(prevPermissions => {
            let newPermissions = [...prevPermissions];
            
            if (allSelected) {
                // Desmarcar todos los de esta sección
                newPermissions = newPermissions.filter(id => !sectionIds.includes(id));
            } else {
                // Marcar todos los de esta sección
                sectionIds.forEach(id => {
                    if (!newPermissions.includes(id)) {
                        newPermissions.push(id);
                    }
                });
            }
            
            return newPermissions;
        });
    };

    // 🔍 Función para verificar si todos los permisos de una sección están seleccionados
    const areAllSectionPermissionsSelected = (sectionPermissions) => {
        const sectionIds = sectionPermissions.map(p => p.id);
        return sectionIds.length > 0 && sectionIds.every(id => rolePermissions.includes(id));
    };

    const permisosSecciones = buildPermisosRolSecciones({
        permisosGenerales,
        permisosAdministracion,
        permisosAgenda,
        permisosPersonal,
        permisosReportes,
        permisosPacientes,
        permisosFacturacion,
        permisosContabilidad,
        permisosIndicadores,
        permisosConfiguracion,
        permisosLaboratorio,
    });

    const toggleAllGlobal = () => {
        const allIds = getAllPermissionIds(permisosSecciones);
        const allSelected = allIds.length > 0 && allIds.every((id) => rolePermissions.includes(id));

        setRolePermissions((prev) => {
            if (allSelected) {
                return prev.filter((id) => !allIds.includes(id));
            }
            const next = [...prev];
            allIds.forEach((id) => {
                if (!next.includes(id)) {
                    next.push(id);
                }
            });
            return next;
        });
    };

    const areAllGlobalSelected = () => {
        const allIds = getAllPermissionIds(permisosSecciones);
        return allIds.length > 0 && allIds.every((id) => rolePermissions.includes(id));
    };

    useEffect(()=>{

        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        // 🔒 VALIDACIÓN DE PERMISOS - Verificar acceso a crear roles
        const tienePermiso = userdata.up && userdata.up.includes('administrarSeguridad');
        
        if (!tienePermiso) {
            setHasPermission(false);
            return; // Detener ejecución si no tiene permisos
        }

        setHasPermission(true);

        // ✅ Ya NO necesitas config - el interceptor agrega el token automáticamente
        
        axios.get('/get-client?uid='+userdata.user_id)
            .then(response => {
                if (response.status===200) {
                    //setUsername(userdata.user_name);
                    
                    setClient(response.data);
                    console.log('Client: '+client.client_id);
                    setLoggedIn(true);
                }
            })
            .catch(error => {
                
                console.log('err: '+error);
            });
        

        axios.get('/permissions')
            .then(response => {
                if (response.status===200) {
                    const listaPermisos = aplicarPermisoAdministrarSuscripcion(response.data);
                    setPermissions(listaPermisos);

                    setPermisosPacientes(getPermisosPorCategoria(listaPermisos,'pacientes'));
                    setPermisosGenerales(getPermisosPorCategoria(listaPermisos,'general'));
                    setPermisosFacturacion(getPermisosPorCategoria(listaPermisos,'facturacion'));
                    setPermisosContabilidad(getPermisosPorCategoria(listaPermisos,'contabilidad'));
                    setPermisosAgenda(getPermisosPorCategoria(listaPermisos,'agenda'));
                    setPermisosAdministracion(getPermisosPorCategoria(listaPermisos,'administracion'));
                    setPermisosPersonal(getPermisosPorCategoria(listaPermisos,'personal'));
                    setPermisosReportes(getPermisosPorCategoria(listaPermisos,'reportes'));
                    setPermisosIndicadores(getPermisosPorCategoria(listaPermisos,'indicadores'));
                    setPermisosConfiguracion(getPermisosPorCategoria(listaPermisos,'configuracion'));
                    setPermisosLaboratorio(getPermisosPorCategoria(listaPermisos,'laboratorio'));

                    setLoggedIn(true);
                }
            })
            .catch(error => {
                
                console.log('err: '+error);
            });
    },[]);


    const handleSubmit = (e) => {
        e.preventDefault();
        setLoading(true);

        /*if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }*/

        const conf = {
            /*headers: { Authorization: 'Bearer ' + userdata.access_token },*/
            client_id: client.client_id,
            name: roleName,
            description: roleDescription,
            permissions: JSON.stringify(rolePermissions)
        };
        
        axios.post('/role', conf)
            .then(
                response => {
                    setLoading(false);

                    history.push('/roles');
                }
            )
            .catch(
                err => {
                    console.log('ERR: '+err.response.data.errors)

                    //setErrorlist(err.response.data.errors);
                    setLoading(false);
                }
            )
    }

    // 🔒 PROTECCIÓN DE RUTA - Si no tiene permisos, mostrar página de acceso denegado
    if (hasPermission === false) {
        return <Unauthorized />;
    }

    if (loggedIn) {
        return (
            
            <div className="hold-transition">
                <style>{PERMISOS_ROL_STYLES}</style>
                <Header client={client} />
                <Aside client={client} activelink="settings" />
                
                <div className="content-wrapper">
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-8">
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item" key="bc1"><Link to="/home">Home</Link></li>
                                        <li className="breadcrumb-item" key="bc2"><Link to="/settings">Configuración</Link></li>
                                        <li className="breadcrumb-item" key="bc3"><Link to="/parametros-sistema">Parámetros del Sistema</Link></li>
                                        <li className="breadcrumb-item" key="bc4"><Link to="/security">Seguridad y Permisos</Link></li>
                                        <li className="breadcrumb-item" key="bc5"><Link to="/roles">Roles de usuario</Link></li>
                                        <li className="breadcrumb-item" key="bc6">Nuevo rol</li>
                                    </ol>
                                </div>
                            </div>
                            <div className="row mb-2">
                                <div className="col-sm-8">
                                    <h1 className="m-0">Nuevo rol</h1>
                                </div>
                            </div>
                        </div>
                    </div>
                    <section className="content" >
                        <div className="container-fluid">

                            <div className="row">
                                <div className="col-md-12">
                                    
                                    <form id="role-form" onSubmit={handleSubmit}>
                                        <div className="card">
                                            <div id="infobasica">
                                                <div className="card-body">

                                                    <div className="row">
                                                        <div className="col-md-6">
                                                            <div className="form-group">
                                                                <label htmlFor="roleName">Nombre <span className="text-danger">*</span></label>
                                                                <input type="text" name="name" className="form-control" id="roleName" onChange={(e) => setRoleName(e.target.value)} required disabled={loading} />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6">
                                                            <div className="form-group">
                                                                <label htmlFor="roleDescription">Descripción <span className="text-danger">*</span></label>
                                                                <input type="text" name="description" className="form-control" id="roleDescription" onChange={(e) => setRoleDescription(e.target.value)} disabled={loading} required />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <PermisosRolAcordeones
                                            idPrefix="new-role"
                                            sections={permisosSecciones}
                                            selectedIds={rolePermissions}
                                            onTogglePermission={addPermission}
                                            onToggleSection={toggleAllPermissions}
                                            areAllSectionSelected={areAllSectionPermissionsSelected}
                                            onToggleAllGlobal={toggleAllGlobal}
                                            areAllGlobalSelected={areAllGlobalSelected}
                                        />

                                        <div className="d-flex gap-2" style={{margin: '30px 0 30px 8px'}}>
                                            <Link to="/roles" className="btn btn-secondary">
                                                Cancelar
                                            </Link>
                                            <button type="submit" className="btn btn-primary" disabled={loading}>
                                                Crear rol&nbsp;
                                                {loading ? (<span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>) : null }
                                            </button>
                                        </div>
                                                {/*
                                                    <div className="row">
                                                        <div className="col-md-6">

                                                            {
                                                                permissions.map((permission) => 
                                                                    <div className="sm-switch-component">
                                                                        <label>{permission.name}</label>
                                                                        <div className="sm-switch-container" id={'permission-'+permission.id} onClick={() => addPermission(permission.id)}>
                                                                            <span className="sm-switch"></span>
                                                                        </div>
                                                                    </div>
                                                                )
                                                            }

                                                        </div>
                                                        <div className="col-md-6">

                                                        </div>
                                                    </div>
                                                    <div className="row" style={{marginTop: '30px'}}>
                                                        <div className="col-md-6">
                                                            
                                                            <button type="submit" className="btn btn-primary btn-block">
                                                                Crear rol&nbsp;
                                                                {loading ? (<span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>) : null }
                                                                
                                                            </button>
                                                        </div>
                                                    </div>
                                                */}
                                                
                                    </form>

                                </div>          
                            </div>

                        </div>
                    </section>
                </div>
                <Footer showToast={false} />
            </div>
            
        );
    }

    return (
        <Loading />
    );
}
export default NewRole;